import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import Global from '../../store/global-selectors';
import { useInventoryAllocation } from '../../hooks/inventory/use-inventory-allocation';
import inventoryIsDisabled from './inventoryIsDisabled';
import fulfillmentPlansHaveCorrectStatus from './fulfillmentPlansHaveCorrectStatus';
import { AllocationStatus } from '../../constants/allocation';

export const useIsAllocateDisabled = () => {
  const fulfillmentPlanIds = useSelector(Global.selectSelectedOrdersIds);
  const fulfillmentPlans = useSelector(
    (state) =>
      Global.selectEntitiesFulfillmentPlansByIds(state, {
        fulfillmentPlanIds,
      }).filter((fulfillmentPlan) => !!fulfillmentPlan) || [],
  );
  const { isAllocating } = useInventoryAllocation();
  const isInventoryDisabled = useSelector(inventoryIsDisabled);
  const isDrawerLoading = useSelector(Global.selectOrdersDrawerLoadingState);

  const { fpAllocationStatusEquivalency, fpDeallocationStatusEquivalency } = useMemo(() => {
    const orderAllocationStatuses = fulfillmentPlans.filter((fp) => !!fp).map(({ allocationStatus }) => ({ allocationStatus }));
    return {
      fpAllocationStatusEquivalency: orderAllocationStatuses.every((status) => status.allocationStatus === AllocationStatus.Allocated),
      fpDeallocationStatusEquivalency: orderAllocationStatuses.every(
        (status) => status.allocationStatus === AllocationStatus.Unallocated || status.allocationStatus === AllocationStatus.Unknown,
      ),
    };
  }, [fulfillmentPlans]);

  const isButtonDisabled = useMemo(
    () => isInventoryDisabled || fulfillmentPlans.length === 0 || !fulfillmentPlansHaveCorrectStatus(fulfillmentPlans),
    [fulfillmentPlans, isInventoryDisabled],
  );

  const isAllocationDisabled = isButtonDisabled || isAllocating || isDrawerLoading || fpAllocationStatusEquivalency;
  const isDeallocationDisabled = isButtonDisabled || isAllocating || isDrawerLoading || fpDeallocationStatusEquivalency;

  return useMemo(
    () => ({
      isButtonDisabled,
      isAllocationDisabled,
      isDeallocationDisabled,
    }),
    [isAllocationDisabled, isButtonDisabled, isDeallocationDisabled],
  );
};
